import React, { useState } from "react";
import { updateBusinessProfile } from "../../../../../services/businessService";

const YearsInBusiness = ({ initialYears }) => {
    const [years, setYears] = useState(initialYears || 0);
    const [tempYears, setTempYears] = useState(years);
    const [loading, setLoading] = useState(false);

    return (
        <div className="experience-block">
            <h3 className="experience-title">Years in Business</h3>
                <div className="experience-value-row">
                    <p className="experience-value">{years}+ years</p>
                </div>
        </div>
    );
};

export default YearsInBusiness;
